import {
  AnyAction,
  combineReducers,
  configureStore,
  Reducer,
  Store as ToolkitStore
} from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import authDataReducer from "./slice/AuthDataSlice";
import filterReducer from "./slice/FilterSlice";
import hintModalReducer from "./slice/HintModalSlice";
import ITRFilingReducer from "./slice/ITRFilingSlice";
import loggedInUserReducer from "./slice/LoggedInUserSlice";
import toastReducer from "./slice/ToastMsgSlice";

const combinedReducer = combineReducers({
  authData: authDataReducer,
  loggedInUserReducer: loggedInUserReducer,
  toastReducer: toastReducer,
  filterReducer: filterReducer,
  ITRFilingReducer: ITRFilingReducer,
  hintModalReducer: hintModalReducer
});

const rootReducer: Reducer = (rootState: RootState, action: AnyAction) => {
  if (action.type === "loggedInUserSlice/logout") {
    rootState = {} as RootState;
  }
  return combinedReducer(rootState, action);
};

export interface ThunkExtraArguments {
  store: ToolkitStore;
}

const thunkArguments = {} as ThunkExtraArguments;

const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: thunkArguments
      }
    })
});

thunkArguments.store = Store;

export type RootState = ReturnType<typeof combinedReducer>;

export type AppDispatch = typeof Store.dispatch;

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default Store;
